import type { FC, MouseEvent } from 'react';

import { QrCode } from '../../assets/qrCode';
import { useEscapeKey } from '../../hooks/useEscapeKey';
import styles from './MaxQrModal.module.scss';
import React from 'react';
import { createPortal } from 'react-dom';
import { IconClose } from '../../assets/icons/icons';

interface MaxQrModalProps {
    open: boolean;
    onClose: () => void;
}

export const MaxQrModal: FC<MaxQrModalProps> = ({ open, onClose }) => {
    useEscapeKey(open, onClose);

    if (!open) return null;

    const handleBackdropClick = (event: MouseEvent<HTMLDivElement>): void => {
        if (event.target === event.currentTarget) onClose();
    };

    return createPortal(
        <div className={styles.overlay} onClick={handleBackdropClick}>
            <div
                className={styles.card}
                role="dialog"
                aria-modal="true"
                aria-labelledby="maxQrTitle"
            >
                <button
                    type="button"
                    className={styles.close}
                    onClick={onClose}
                    aria-label="Закрыть QR-код"
                >
                    <IconClose />
                </button>

                <div className={styles.kicker}>Связь в мессенджере MAX</div>

                <h3 id="maxQrTitle">Отсканируйте QR-код</h3>

                <p>Наведите камеру телефона на код, чтобы перейти к сервису в MAX.</p>

                <div className={styles.code}>
                    <QrCode role="img" aria-label="Увеличенный QR-код для перехода в MAX" />
                </div>

                <div className={styles.hint}>Окно можно закрыть кликом вне карточки или клавишей Esc</div>
            </div>
        </div>,
        document.body,
    );
};